const envConfig = {
  API_ENDPOINT_URL: `${process.env.REACT_APP_API_URL}`,
  REACT_APP_GOOGLE_MAPS_API_KEY: `${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
  Notifictions_HUB: `${process.env.REACT_APP_API_URL}/notifications`,
  RealTime_HUB: `${process.env.REACT_APP_API_URL}/realtime-hub`
};

export const env = envConfig;
